import { useState } from "react";
import { DropdownMenu } from "./DropDownMenu";
import { OptionButton } from "../atoms";

type OptionProps = {
  item: string;
  action: () => void;
};

type ButtonWithDropDownMenuProps = {
  options: OptionProps[];
  position: "top" | "bottom" | "left" | "right";
};

export const ButtonWithDropDownMenu = ({
  options,
  position,
}: ButtonWithDropDownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <OptionButton
        onClick={() => setIsOpen(true)}
        tooltipText="menu opcional"
      />
      <DropdownMenu
        isOpen={isOpen}
        onOutsideClickAction={() => setIsOpen(false)}
        options={options}
        position={position}
      />
    </div>
  );
};